import { NavLink } from "react-router-dom";
import {
  Home,
  FileText,
  Settings,
  User,
  X,
  CreditCard,
  Package,
  // Eye,
  Building,
  Users,
  ShieldCheck,
} from "lucide-react";

interface DrawerProps {
  isOpen: boolean;
  onClose: () => void;
}

const navigationItems = [
  { name: "Dashboard", icon: Home, path: "/", isReleased: true },
  { name: "Documents", icon: FileText, path: "/documents", isReleased: true },
  // { name: "OCR Results", icon: Eye, path: "/ocr" },
  { name: "Products", icon: Package, path: "/products", isReleased: true },
  {
    name: "Product Catalog",
    icon: Building,
    path: "/product-catalog",
    isReleased: false,
  },
  { name: "Companies", icon: Users, path: "/companies", isReleased: false },
  {
    name: "Validate Product",
    icon: ShieldCheck,
    path: "/validate-product",
    isReleased: false,
  },
  { name: "Profile", icon: User, path: "/profile", isReleased: true },
  { name: "Pricing", icon: CreditCard, path: "/pricing", isReleased: true },
  { name: "Settings", icon: Settings, path: "/settings", isReleased: true },
];

export function Drawer({ isOpen, onClose }: DrawerProps) {
  return (
    <>
      {/* Backdrop */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-secondary-900/50 transition-opacity z-40"
          onClick={onClose}
          aria-label="Close menu"
          tabIndex={-1}
        />
      )}

      {/* Drawer */}
      <aside
        className={`fixed inset-y-0 left-0 w-64 bg-white shadow-xl transform transition-transform duration-300 ease-in-out z-50 ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        }`}
        aria-hidden={!isOpen}
        aria-label="Sidebar navigation"
      >
        <div className="flex items-center justify-between p-4 border-b border-secondary-200">
          <h2 className="text-lg font-semibold text-secondary-900">Menu</h2>
          <button
            type="button"
            onClick={onClose}
            className="p-2 rounded-md text-secondary-400 hover:text-secondary-500 hover:bg-secondary-100"
            aria-label="Close menu"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        <nav className="p-4 space-y-1">
          {navigationItems
            .filter((item) => item.isReleased)
            .map((item) => (
              <NavLink
                key={item.name}
                to={item.path}
                onClick={onClose}
                className={({ isActive }) =>
                  `flex items-center px-4 py-3 text-sm font-medium rounded-lg transition-colors ${
                    isActive
                      ? "bg-primary-50 text-primary-600"
                      : "text-secondary-600 hover:bg-secondary-50"
                  }`
                }
              >
                <item.icon className="h-5 w-5 mr-3" />
                {item.name}
              </NavLink>
            ))}
        </nav>
      </aside>
    </>
  );
}
